<template>
	<div>
		<bread-crumbs
			:title="
				mode === 'update' && activeTab === 1
					? $t('Crud.Update') + ' ' + $t('Company')
					: mode === 'create' && activeTab === 1
					? $t('general.New2') + ' ' + $t('Company')
					: $t('ListOfCompanies')
			"
			:subTitle="
				mode === 'update' && activeTab === 1
					? $t('CompanyFormTitleUpdate')
					: mode === 'create' && activeTab === 1
					? $t('CompanyFormTitleCreate')
					: $t('general.SubtitleCompany')
			"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		/>
		<vx-card v-if="companyData" id="company-card-main">
			<div slot="no-body" class="tabs-container px-6 pt-6">
				<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
					<vs-tab :label="$t('ListOfCompanies')" icon-pack="feather" icon="icon-list">
						<div class="tab-text">
							<company-list-view-card
								class="mt-4"
								:data="companyData"
								@selectedCompanyEmit="selectedCompanyEmit"
								@selectedCompanyCreateAdminResourceEmit="selectedCompanyCreateAdminResource"
								@selectedCompanyCreateServirouteEmit="selectedCompanyCreateServiroute"
							/>
						</div>
					</vs-tab>

					<vs-tab :label="tabLabelText" icon-pack="feather" icon="icon-info">
						<div class="tab-text overflow-tab-content">
							<form-wizard
								color="rgba(var(--vs-primary), 1)"
								errorColor="rgba(var(--vs-danger), 1)"
								:title="null"
								:subtitle="null"
								:finishButton="false"
								finishButtonText="Finalizar"
								:backButtonText="prevButtonText"
								:nextButtonText="nextButtonText"
								@on-change="handleChange"
							>
								<!-- tab 1 content -->
								<tab-content
									v-if="mode === 'create' || mode === 'update'"
									:title="$t('CompanyForm.CompanyInformation')"
									class="mb-5"
									icon="feather icon-briefcase"
									:before-change="validateStep1"
								>
									<form data-vv-scope="step-1">
										<company-form
											:data="company"
											:isEditActive="isEditActive"
											@changeActiveTabEmit="changeActiveTab"
											@getFormDataCompanyEmit="getFormDataCompany"
											ref="CompanyForm"
										/>
									</form>
								</tab-content>

								<!-- tab 2 content -->
								<tab-content
									v-if="mode === 'create' || mode === 'createAdmin'"
									:title="$t('CompanyForm.AdminResource')"
									class="mb-5"
									icon="feather icon-user"
									:before-change="validateStep2"
								>
									<form data-vv-scope="step-2">
										<first-resource-form
											@getFormDataResourceEmit="getFormDataResource"
											:dataEmail="dataEmail"
											ref="FirstResourceForm"
										/>
									</form>
								</tab-content>

								<!-- tab 3 content -->
								<tab-content
									v-if="mode === 'create' || mode === 'createAdmin'"
									:title="$t('CompanyForm.Summary')"
									class="mb-5"
									icon="feather icon-layout"
									:before-change="validateStep3"
								>
									<form data-vv-scope="step-3">
										<company-resum-create :company="company" :resource="resource" :mode="mode" />
									</form>
								</tab-content>

								<!-- tab 4 content -->
								<tab-content
									v-if="mode === 'create' || mode === 'createAdmin'"
									:title="$t('CompanyForm.Finish')"
									class="mb-5"
									icon="feather icon-send"
									:before-change="validateStep4"
								>
									<vx-card no-shadow card-border>
										<form data-vv-scope="step-4">
											<h4>{{ $t("Company") }}:</h4>
											<p class="text-success" v-if="companyStatus === true">
												{{ $t("TextConfirmCompanyCreate") }}
											</p>

											<h4 class="mt-5">{{ $t("CompanyForm.AdminResource") }}:</h4>
											<p class="mb-5 text-success" v-if="resourceStatus === true">
												{{ $t("CompanyForm.AdminResourceSuccess") }}
											</p>
											<p class="mb-5" v-if="resourceStatus === false">
												{{ $t("CompanyForm.AdminResourceError") }}
											</p>
											<p class="mb-5 text-danger" v-if="resourceStatus === false">
												{{ $t("CompanyForm.AdminResourceFailed") }}
											</p>

											<a
												v-if="resourceStatus !== null"
												href="#"
												class="mt-5 text-inherit underline cursor-pointer"
												@click="activeTab = 0"
												color="success"
												>{{ $t("CompanyForm.ViewCompanyList") }}</a
											>

											<h4 class="mt-5">{{ $t("CompanyForm.RequiredConfig") }}:</h4>
											<p v-if="companyStatus !== null && resourceStatus !== null">
												<vs-icon icon="warning_amber" size="22px" color="#ff9f43"></vs-icon>
												{{ $t("CompanyForm.ActivateSitidadaText1") }}

												<router-link
													:to="{
														name: 'app-setting',
														params: {company_id: resultCompanyId, config_type: 'SITIDATA'},
													}"
													class="text-inherit underline"
													>{{ $t("CompanyForm.ActivateSitidadaText2") }}</router-link
												>
											</p>
										</form>
									</vx-card>
								</tab-content>

								<!-- tab 5 content -->
								<tab-content
									v-if="mode === 'createServiroute'"
									:title="$t('ServiRoutes')"
									class="mb-5"
									icon="feather icon-briefcase"
									:before-change="validateStep1"
								>
									<form data-vv-scope="step-5">
										<p>{{ $t("CompanyForm.ActivateServiroutes") }}</p>
										<resource-list
											class="mt-4"
											:relatedIds="[]"
											:companyId="resultCompanyId"
											:removeColumns="true"
											:customConfig="resourceListConfig"
										></resource-list>
									</form>
								</tab-content>

								<template slot="next">
									<vs-button color="primary">{{ nextButtonText }}</vs-button>
								</template>

								<template slot="prev">
									<vs-button color="primary" v-show="disbableBottonPrev">{{
										prevButtonText
									}}</vs-button>
								</template>

								<template slot="finish">
									<vs-button
										color="primary"
										class="mr-2"
										v-show="mode === 'update'"
										@click="updateData"
										>{{ $t("Crud.Update") }}
									</vs-button>
									<vs-button
										color="danger"
										class="mr-2"
										v-show="mode === 'createServiroute'"
										@click="activeTab = 0"
										>{{ $t("Cancel") }}
									</vs-button>
									<vs-button
										color="primary"
										v-show="mode === 'createServiroute'"
										@click="enableServiroute"
										>{{ $t("Save") }}
									</vs-button>
								</template>
							</form-wizard>
						</div>
					</vs-tab>
				</vs-tabs>
			</div>
		</vx-card>
	</div>
</template>
<script>
import {FormWizard, TabContent} from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import CompanyForm from "./CompanyForm.vue";
import Company from "@/models/Company.js";
import Resource from "@/models/Resource.js";
import CompanyListView from "./CompanyListView.vue";
import FirstResourceForm from "./FirstResourceForm.vue";

import moduleCompany from "@/store/company/moduleCompany.js";
import moduleResource from "@/store/resource/moduleResource.js";

import CompanyResumCreate from "./CompanyResumCreate.vue";
import ResourceList from "@/components/resource/user-list/ResourceList.vue";
import CompanyListViewCard from "./CompanyListViewCard.vue";

import DateUtils from "@/helpers/DateUtils.js";
import BreadCrumbs from "../../core/components/BreadCrumbs.vue";

export default {
	name: "Company",
	data() {
		return {
			company: new Company({}),
			resource: new Resource({}),
			companyData: {},
			activeTab: 0,
			isEditActive: false,
			disbableBottonPrev: true,
			activeAlert: true,
			nextButtonI18: "Next",
			preButtonI18: "Previous",
			resourceStatus: null,
			companyStatus: null,
			mode: "create",
			resultCompanyId: 0,
			resultResourceId: 0,
			//Config Resource List
			resourceListConfig: {
				rowSelection: "single",
				activeCheckbox: true,
				columns: ["id", "name", "lastname", "username", "email", "identification", "alias"],
				actionDropdown: false,
				popupMode: true,
				link: false,
				importMode: true,
				btnAssigResources: false,
				module: "company",
			},
			serviroutes_company_id: 0,
			emailExist: false,
		};
	},
	components: {
		CompanyForm,
		CompanyListView,
		FormWizard,
		TabContent,
		FirstResourceForm,
		CompanyResumCreate,
		ResourceList,
		CompanyListViewCard,
		BreadCrumbs,
	},
	computed: {
		tabLabelText() {
			if (this.activeTab === 1 && this.mode === "createServiroute") {
				return this.$t("Add") + " " + "Serviroute";
			} else if (this.company.id > 0 && this.activeTab === 1) {
				this.isEditActive = true;
				return this.$t("UpdateCompany");
			} else {
				this.isEditActive = false;
				return this.$t("NewCompany");
			}
		},
		nextButtonText: {
			get() {
				return this.$t(this.nextButtonI18);
			},
			set(val) {
				this.nextButtonI18 = val;
			},
		},
		prevButtonText: {
			get() {
				return this.$t(this.preButtonI18);
			},
			set(val) {
				this.preButtonI18 = val;
			},
		},
	},
	methods: {
		goTo(path) {
			this.$router.push(path);
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		formatDates(dateString) {
			// 'Tue, 18 Mar 2025 19:35:52 GMT'
			const newDate = new Date(dateString);
			return DateUtils.toDefaultDateTime(newDate, "YYYY-MM-DD HH:mm:ss");
		},
		createCompany() {
			this.company.date_init = this.formatDates(this.company.date_init);
			this.company.date_end = this.formatDates(this.company.date_end);
			delete this.company.id;

			this.openLoading();
			this.$store
				.dispatch("moduleCompany/addItemCompany", this.company)
				.then((res) => {
					if (res.data.id) this.companyStatus = true;
					this.resultCompanyId = res.data.id;
					this.resource.typology_id = res.data.resource_typology_id;
					delete this.resource.id;

					return this.$store.dispatch("moduleResource/addResource", {
						...this.resource,
						company_id: this.company.id,
						role_id: res.data.admin_role_id,
					});
				})
				.then((res) => {
					if (res.data.id) this.resourceStatus = true;
					this.resultResourceId = res.data.id;
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyCreate"),
						text: this.$t("TextConfirmCompanyCreate"),
					});
					this.closeLoading();
				})
				.catch((err) => {
					this.resourceStatus = false;
					console.error(err);
					this.closeLoading();
				});
		},
		createAdminResource() {
			this.resource.typology_id = this.company.resource_typology_id;
			delete this.resource.id;
			this.openLoading();

			this.$store
				.dispatch("moduleResource/addResource", {
					...this.resource,
					company_id: this.company.id,
					role_id: this.company.admin_role_id,
				})
				.then((res) => {
					this.resourceStatus = true;
					this.closeLoading();
					this.$vs.notify({
						color: "success",
						title: this.$t("Resource.Create.Success.Title"),
						text: this.$t("Resource.Create.Success.Text"),
					});
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		updateData() {
			this.company.date_init = this.formatDates(this.company.date_init);
			this.company.date_end = this.formatDates(this.company.date_end);

			this.openLoading();
			this.$store
				.dispatch("moduleCompany/updateItem", this.company)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyUpdate"),
						text: this.$t("TextConfirmCompanyUpdate"),
					});
					this.closeLoading();
					this.activeTab = 0;
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		enableServiroute() {
			if (this.serviroutes_company_id === 0) {
				this.createServiroutesCompanyWithLogin();
			} else {
				this.createServiroutesCompany();
			}
		},
		createServiroutesCompany() {
			const payload = {
				company_id: this.resultCompanyId,
				resource_id: this.resultResourceId || this.$store.state.moduleResource.currentSelectedResource.id,
			};
			this.openLoading();
			this.$store
				.dispatch("moduleCompany/createServirouteCompany", payload)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyCreate"),
						text: this.$t("TextConfirmCompanyCreate"),
					});
					this.activeTab = 0;
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		createServiroutesCompanyWithLogin() {
			this.openLoading();
			this.$store
				.dispatch("moduleCompany/serviroutesLogin")
				.then((response) => {
					const payload = {
						company_id: this.resultCompanyId,
						resource_id:
							this.resultResourceId || this.$store.state.moduleResource.currentSelectedResource.id,
					};
					return this.$store.dispatch("moduleCompany/createServirouteCompany", payload);
				})
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyCreate"),
						text: this.$t("TextConfirmCompanyCreate"),
					});
					this.activeTab = 0;
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		createSitidata() {
			this.$router
				.push({name: "app-setting", params: {company_id: this.resultCompanyId, config_type: "SITIDATA"}})
				.catch(() => {});
		},
		selectedCompanyEmit(company, createAdmin) {
			this.company = new Company(company);
			this.mode = createAdmin;
			this.activeTab = 1;
		},
		selectedCompanyCreateAdminResource(company, createAdmin) {
			this.company = new Company(company);
			// Agregamos al objeto company los nuevos atributos capturados desde el listado para agregar al body del recurso
			this.company.resource_typology_id = company.resource_typology_id;
			this.company.admin_role_id = company.admin_role_id;
			this.mode = createAdmin;
			this.activeTab = 1;
		},
		selectedCompanyCreateServiroute(company, createAdmin) {
			this.company = new Company(company);
			this.resultCompanyId = this.company.id;
			this.mode = createAdmin;
			this.activeTab = 1;
		},
		changeActiveTab(tabNum) {
			this.activeTab = tabNum;
		},
		handleChange(prevIndex, nextIndex) {
			if (prevIndex === 1 && nextIndex === 0) {
			}
			if (prevIndex === 2 && nextIndex === 1) {
				this.nextButtonText = "Next";
			}
			if (prevIndex === 1 && nextIndex === 2) {
				this.nextButtonText = "Save";
			}
			if (prevIndex === 2) {
				this.disbableBottonPrev = false;
			}
		},
		getFormDataCompany(company) {
			this.company = new Company(company);
		},
		getFormDataResource(resource) {
			this.resource = new Resource(resource);
		},
		validateStep1() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-1").then((result) => {
					if (result) {
						if (this.mode === "create") {
							this.$refs.CompanyForm.getDataFormCompany();
						}
						const {valid, invalidFields} = this.company.validateCompany();
						if (valid) {
							resolve(true);
						} else {
							reject("correct all values");
							this.$vs.notify({
								color: "danger",
								title: this.$t("CompanyForm.InvalidFields"),
								text: this.$t(`${invalidFields[0]}`),
							});
						}
					} else {
						reject("correct all values");
						this.$vs.notify({
							color: "danger",
							title: this.$t("CompanyForm.InvalidFields"),
							text: "Todos los campos son requeridos para continuar",
						});
					}
				});
			});
		},
		validateStep2() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-2").then((result) => {
					if (result) {
						this.$refs.FirstResourceForm.getDataFormResource();
						const {valid, invalidFields} = this.resource.validateResourceData();
						if (valid && !this.emailExist) {
							resolve(true);
						} else {
							reject("correct all values");
							this.$vs.notify({
								color: "danger",
								title: this.$t("CompanyForm.InvalidFields"),
								text:
									invalidFields.length > 0
										? this.$t(`${invalidFields[0]}`)
										: this.$t("CompanyForm.EmailAlreadyExist"),
								time: 5000,
							});
						}
					} else {
						reject("correct all values");
						this.$vs.notify({
							color: "danger",
							title: this.$t("CompanyForm.InvalidFields"),
							text: "Todos los campos son requeridos para continuar.",
						});
					}
				});
			});
		},
		validateStep3() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-3").then((result) => {
					if (result) {
						if (this.company.id > 0) {
							if (this.mode === "update") {
								this.updateData();
							} else {
								this.createAdminResource();
							}
						} else {
							this.createCompany();
						}
						resolve(true);
					} else {
						reject("correct all values");
					}
				});
			});
		},
		validateStep4() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-4").then((result) => {
					if (result) {
						//this.$router.push("/apps/resource/resource-create");
						resolve(true);
					} else {
						reject("correct all values");
					}
				});
			});
		},
		checkServirouterSession() {
			this.$store
				.dispatch("moduleCompany/checkAuthSessions")
				.then((res) => {
					if (Object.hasOwnProperty.call(res.data, "serviroutes_company_id")) {
						this.serviroutes_company_id = res.data.serviroutes_company_id;
					}
				})
				.catch((err) => console.error(err));
		},
		dataEmail(val) {
			this.emailExist = val;
		},
	},
	watch: {
		activeTab(val) {
			if (val === 0) {
				this.company = new Company({});
				this.mode = "create";
			}
		},
		mode(val) {
			switch (val) {
				case "create":
					break;
				case "update":
					break;
				case "createServiroute":
					break;
				default:
					break;
			}
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		if (!moduleCompany.isRegistered) {
			this.$store.registerModule("moduleCompany", moduleCompany);
			moduleCompany.isRegistered = true;
		}

		this.checkServirouterSession();
	},
};
</script>

<style lang="scss" scoped>
#company-card-main {
	height: 100%;
}
</style>
